import React from 'react';
import scaleSize from '../../../utils/scale-size';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={scaleSize(48)}
    height={scaleSize(48)}
    viewBox="0 0 48 48"
  >
    <g className="stroke-change" fill="none" fillRule="evenodd" stroke="#9F9F9F">
      <path
        strokeLinecap="round"
        strokeWidth="3"
        d="M9.703 29.997C12.047 35.579 17.566 39.5 24 39.5c8.56 0 15.5-6.94 15.5-15.5 0-5.406-2.768-10.166-6.964-12.94A15.428 15.428 0 0 0 24 8.5c-5.52 0-10.367 2.886-13.113 7.232M29 29l-5-4.999"
      />
      <path
        className="fill-change"
        fill="#9F9F9F"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M8 13l5 5H8z"
      />
      <path strokeLinecap="round" strokeWidth="3" d="M24 24.001V16" />
    </g>
  </svg>
);
